
module.exports = function ($host, config) {

  // Config
  var focusClass = 'is-focused';

  // Dom
  var $value = $('[data-number-value]', $host);
  var $plus  = $('[data-number-plus]',  $host);
  var $minus = $('[data-number-minus]', $host);

  // State
  var state = {
    value: 0
  };

  // Functions
  function adjust (n) {
    state.value = Math.max(0, state.value + n);
    $value.val(state.value);
    $value.trigger('change');
  }

  function adjustBy (n) {
    return function _adjustBy () {
      $value.focus();
      adjust(n);
    }
  }

  function update () {
    var value = $value.val();
    state.value = value === '' ? 0 : parseInt(value, 10)
  }

  function focus (mode) {
    return function _focus () {
      $host.toggleClass(focusClass, mode);
    }
  }

  // Listeners
  $plus.on('click',   adjustBy(+1));
  $minus.on('click',  adjustBy(-1));
  $value.on('change', update);
  $value.on('focus',  focus(true));
  $value.on('blur',   focus(false));

  // Init
  update();

};

